import { useRoutes } from 'react-router-dom';
import router from './routes';
import { SnackbarProvider } from 'notistack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import useAuth from 'src/hooks/useAuth';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import SuspenseLoader from './components/atoms/SuspenseLoader';
import { MessageProvider } from './contexts/MessageContext';
import { LicenseInfo } from '@mui/x-license-pro';
import { CardProvider } from './contexts/CardContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { EditsProvider } from './contexts/EditsContext';
import { SidebarProvider } from './contexts/SidebarContext';



function App() {
  const content = useRoutes(router);
  const auth = useAuth();
  LicenseInfo.setLicenseKey('bf82327f8378a283881f898302c93066Tz0xMjMyMjAsRT0xNzk3NDY1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

  return (
    
      <SettingsProvider>
        <ThemeProvider>
        <SidebarProvider>

          <EditsProvider>
            <MessageProvider>
              <CardProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <SnackbarProvider
                    maxSnack={6}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right'
                    }}
                  >
                    <CssBaseline />
                    {auth.isInitialized ? <>
                      {content}

                    </> : <SuspenseLoader />}

                  </SnackbarProvider>
                </LocalizationProvider>
              </CardProvider>
            </MessageProvider>
          </EditsProvider>
        </SidebarProvider>
        </ThemeProvider >
      </SettingsProvider>
    
  );
}
export default App;

